'use strict';

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

module.exports = uuid;



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/lib/uuid.js
// module id = YudH
// module chunks = 3